export default __webpack_public_path__ + "static/media/logo.6c4e5a14.svg";